










import {Component, Prop, Vue} from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';

// Add a type unit to the type ApexAxisChartSeries
type EnergeticChartSeries = ApexAxisChartSeries & { unit: string };

@Component({components: {apexchart: VueApexCharts}})
export default class EnergeticChart extends Vue {
  @Prop({required: true})
  series: { unit: string, data: EnergeticChartSeries };

  @Prop({required: false, default: ""})
  withClimate: string;

  @Prop({required: true})
  isListDisplay: boolean;

  @Prop({default: false})
  loadingData: boolean;

  get seriesSorted(): EnergeticChartSeries {
    return this.series.data.sort((a, b) => a.name.localeCompare(b.name))
  }

  get getMaxYKw(): number {
    let max = 0;
    this.series.data.forEach(it => {
      it.data.forEach(elem => {
        if (elem.y > max) {
          max = elem.y;
        }
      })
    })

    return max;
  }

get yaxis(): ApexYAxis[] {
  // Grouper les séries par unité
  const unitGroups = {};
  this.seriesSorted.forEach(serie => {
    const unit = (serie as any).unit ?? this.series.unit;
    if (!unitGroups[unit]) unitGroups[unit] = [];
    unitGroups[unit].push(serie);
  });

  const isDegree = (unit) => unit === 'degree';

  return this.seriesSorted.map((serie) => {
    const unit = (serie as any).unit ?? this.series.unit;
    const unitText = this.$t(`meter.unitsValue.${unit}`).toString();
    const groupSeries = unitGroups[unit];
    const isFirstInGroup = groupSeries[0] === serie;

    const opposite = isDegree(unit);

    let min = 0;
    let max = isDegree(unit) ? 30 : this.getMaxYKw;
    let minDegree = isDegree(unit) ? -10 : 0;

    let title = "";
    if (isDegree(unit)) {
      title = "Température (°C)";
    } else if (unit == 'Kwh') {
      title = `Consommation (${unitText})`;
    } else {
      title = unitText;
    }

    return {
      seriesName: groupSeries[0]?.name,
      min: isDegree(unit) ? minDegree : min,
      max,
      opposite,
      show: isFirstInGroup,
      labels: { show: isFirstInGroup, formatter: (val) => val?.toFixed(2) },
      title: {
        text: isFirstInGroup ? title : undefined,
      },
    };
  });
}

get options(): ApexCharts.ApexOptions {
  return {
    chart: {
      type: 'line',
      height: this.isListDisplay ? 400 : 420,
      zoom: {
        enabled: false
      }
    },
    legend: {
      showForSingleSeries: true,
      position: 'bottom',
      offsetY: 0,
      height: 40,
    },
    fill: {
      type: 'solid',
    },
    markers: {
      size: 5,
    },
    tooltip: {
      shared: false,
      intersect: true,
    },
    yaxis: this.yaxis,
    xaxis: {
      title: {
        text: 'Température extérieure moyenne',
        offsetY: 10,
      },
      type: 'numeric',
      min: -10,
      max: 30,
      labels: {
        formatter: (val) => {
          try {
            return `${parseInt(val).toFixed(1)} °C`;
          } catch (err) {
            return val;
          }
        },
      },
      tooltip: {
        enabled: false,
      },
    },
  };
}
}
